import React, { useState, useEffect } from "react";
import "leaflet/dist/leaflet.css";
import MapView from "../../components/MapView/MapView";
import ApiManager from "../../ApiManager/ApiManager";
import ManualAddressForm from "../../components/ManualAddressForm/ManualAddressForm";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getContrastColor } from "../../utils/GetContrastColor";

const EditTrip = ({ tripInfo, setEditTrip }) => {
  // console.log("Trip Info:", tripInfo);
  const navigate = useNavigate();

  const [passengers, setPassengers] = useState(tripInfo?.passengers || []);
  const [additionalContacts, setAdditionalContacts] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [cars, setCars] = useState([]);
  const [carTypes, setCarTypes] = useState([]);
  const [tripTypes, setTripTypes] = useState([]);
  const [tripType, setTripType] = useState(tripInfo?.tripType || {});
  const [company, setCompany] = useState(tripInfo?.company?.id || {});
  const [driverId, setDriverId] = useState(tripInfo?.driverTrip?.driver?.id || "");
  const [carId, setCarId] = useState(tripInfo?.driverTrip?.car?.id || "");
  const [charges, setCharges] = useState(tripInfo?.charges || {});
  const [loadingCompanies, setLoadingCompanies] = useState(false);
  const [loadingCarTypes, setLoadingCarTypes] = useState(false);
  const [loadingTripTypes, setLoadingTripTypes] = useState(false);
  const [loadingLables, setLoadingLabels] = useState(false);
  const [loadingPrice, setLoadingPrice] = useState(false); // State to track loading
  const [showPrices, setShowPrices] = useState(false);
  const [billingItems, setBillingItems] = useState([]);
  const [isInputFocusedReporting, setIsInputFocusedReporting] = useState(false);
  const [isInputFocusedDrop, setIsInputFocusedDrop] = useState(false);
  const [selectedBillingItems, setSelectedBillingItems] = useState(
    tripInfo?.billingItems || []
  );
  const [billingItemPayload, setBillingItemPayload] = useState(
    tripInfo?.billingItems || []
  );
  const [labels, setLabels] = useState([]); // Stores all labels
  const [selectedLabelIds, setSelectedLabelIds] = useState(
    tripInfo?.labels?.map((label) => label.id) || []
  );
  const [cities, setCities] = useState([]);
  const [fromCity, setFromCity] = useState(tripInfo?.fromCity || "");
  const [toCity, setToCity] = useState(tripInfo?.toCity || "");

  const [garageData, setGarageData] = useState([]);
  const [selectedGarage, setSelectedGarage] = useState(tripInfo.garageId || "");

  const [contractAutoSwitchEnabled, setContractAutoSwitchEnabled] = useState(
    typeof tripInfo?.contractAutoSwitchEnabled === 'boolean' ? tripInfo.contractAutoSwitchEnabled : false
  );

  // This function has been replaced with the Cloud Storage API version below

  console.log("Billing Items before mapping:", selectedBillingItems);


  const [manualReportingAddress, setManualReportingAddress] = useState({
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    pincode: "",
  });

  const [manualDropAddress, setManualDropAddress] = useState({
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    pincode: "",
  });

  const [mapReportingAddress, setMapReportingAddress] = useState({
    latitude: tripInfo.reportingLocation.latitude,
    longitude: tripInfo.reportingLocation.longitude,
    description: "",
  });
  console.log("mapReportingAddress", mapReportingAddress);

  const [mapDropAddress, setMapDropAddress] = useState({
    latitude: tripInfo.dropLocation.latitude,
    longitude: tripInfo.dropLocation.longitude,
    description: "",
  });

  const handleFileUpload = async (file, index) => {
    if (!file) return;

    try {
      // Delete existing file if there is one
      const existingFile = selectedBillingItems[index]?.imagePath;
      if (existingFile) {
        await deleteStoredFile(existingFile);
      }

      // Get a presigned URL for upload
      const presignedResponse = await ApiManager.storageGetPresignedUploadUrl({
        filename: file.name,
        directory: "images/receipts"
      });

      if (!presignedResponse.ok) {
        throw new Error("Failed to get presigned URL");
      }

      const presignedData = await presignedResponse.json();

      // Upload the file directly to the storage provider
      const uploadResponse = await fetch(presignedData.url, {
        method: 'PUT',
        body: file,
        headers: {
          'Content-Type': file.type
        }
      });

      if (!uploadResponse.ok) {
        throw new Error("Failed to upload file");
      }

      // Save metadata after upload using the fileName from the response
      const metadataResponse = await ApiManager.storageSaveMetadata(presignedData.fileName, presignedData.key);

      if (!metadataResponse.ok) {
        throw new Error("Failed to save metadata");
      }

      handleBillingItemChange(index, "imagePath", presignedData.fileName);
      console.log("upload result", presignedData);
    } catch (error) {
      console.error("Error uploading file:", error);
      toast.error("Failed to upload file. Please try again.");
    }
  };

  const deleteStoredFile = async (fileName) => {
    try {
      const response = await ApiManager.storageDeleteFile(fileName);

      if (!response.ok) {
        throw new Error("Failed to delete file");
      }

      console.log(`File ${fileName} deleted successfully`);
    } catch (error) {
      console.error(`Error deleting file ${fileName}:`, error);
    }
  };

  const handleManualReportingAddressChange = (name, value) => {
    setManualReportingAddress((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleManualDropAddressChange = (name, value) => {
    setManualDropAddress((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const fetchFile = async (imagePath) => {
    if (!imagePath) return;

    try {
      // Get a presigned URL for direct download
      const response = await ApiManager.storageGetPresignedDownloadUrl(imagePath);

      if (!response.ok) {
        throw new Error("Failed to generate presigned URL");
      }

      const result = await response.json();

      // Open the presigned URL directly in a new tab
      window.open(result.url, "_blank");
    } catch (error) {
      console.error("Error fetching file:", error);
    }
  };

  const [mapViewToggles, setMapViewToggles] = useState({
    reportingAddress: true,
    dropAddress: true,
  });

  const toggleView = (section) => {
    setMapViewToggles((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const handleTripTypeChange = (e) => {
    e.preventDefault();
    const selectedTripTypeId = parseInt(e.target.value); // Get the id of the selected trip type
    const selectedType = tripTypes.find(
      (type) => type.id === selectedTripTypeId
    ); // Find the tripType object
    setTripType(selectedType); // Update tripType state with the selected trip type object
  };

  const formatDateTime = (timestamp, type) => {
    if (!timestamp) return "";

    // Create a date object from the timestamp
    const date = new Date(timestamp * 1000);

    // Format the date in IST (UTC+5:30)
    const options = type === "datetime-local"
      ? {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
          timeZone: 'Asia/Kolkata'
        }
      : {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          timeZone: 'Asia/Kolkata'
        };

    // Format the date according to the options
    const formattedDate = new Intl.DateTimeFormat('en-CA', options).format(date);

    // For datetime-local, we need to convert from "YYYY-MM-DD, HH:MM" to "YYYY-MM-DDTHH:MM"
    if (type === "datetime-local") {
      return formattedDate.replace(', ', 'T');
    }

    return formattedDate;
  };

  const [reportingSuggestions, setReportingSuggestions] = useState([]);
  const [dropSuggestions, setDropSuggestions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [reportingInputValue, setReportingInputValue] = useState(
    tripInfo.reportingAddress
  );
  const [dropInputValue, setDropInputValue] = useState(tripInfo.dropAddress);
  const [shouldFetchSuggestions, setShouldFetchSuggestions] = useState(true);
  const [debouncedReportingValue, setDebouncedReportingValue] = useState("");
  const [debouncedDropValue, setDebouncedDropValue] = useState("");

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedReportingValue(reportingInputValue);
    }, 300);

    return () => clearTimeout(handler);
  }, [reportingInputValue]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedDropValue(dropInputValue);
    }, 300);

    return () => clearTimeout(handler);
  }, [dropInputValue]);

  useEffect(() => {
    if (shouldFetchSuggestions && debouncedReportingValue) {
      fetchSuggestions(debouncedReportingValue, "reporting");
    }
  }, [debouncedReportingValue]);

  useEffect(() => {
    if (shouldFetchSuggestions && debouncedDropValue) {
      fetchSuggestions(debouncedDropValue, "drop");
    }
  }, [debouncedDropValue]);

  const fetchSuggestions = async (inputText, addressType) => {
    console.log("about to fecth address ....");
    setIsLoading(true);
    try {
      const params = new URLSearchParams({
        input: inputText,
        "X-Correlation-Id": "94c11eb2-cf0a-407b-b22d-2c4cea9e4725",
        location: "28.5561,77.1", // Latitude and Longitude
        radius: 50, // Search radius in km
        strictbounds: false, // Whether to enforce strict bounds or not
      });
      const response = await ApiManager.getAddressSuggestions(params);
      const data = await response.json();
      // print("suggesstions", data)
      if (addressType === "reporting") {
        setReportingSuggestions(data.predictions || []);
      } else {
        setDropSuggestions(data.predictions || []);
      }
    } catch (error) {
      console.error("Error fetching address suggestions:", error);
      if (addressType === "reporting") {
        setReportingSuggestions([]);
      } else {
        setDropSuggestions([]);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleReportingInputChange = (e) => {
    const value = e.target.value;
    setReportingInputValue(value);
    setShouldFetchSuggestions(true); // Allow fetching new suggestions
    if (value === "") {
      setReportingSuggestions([]);
      setShouldFetchSuggestions(false);
    } else {
      setShouldFetchSuggestions(true); // Allow fetching new suggestions
    }
  };

  const handleDropInputChange = (e) => {
    const value = e.target.value;
    setDropInputValue(value);
    setShouldFetchSuggestions(true); // Allow fetching new suggestions
    if (value === "") {
      setDropSuggestions([]);
      setShouldFetchSuggestions(false);
    } else {
      setShouldFetchSuggestions(true); // Allow fetching new suggestions
    }
  };

  const handleSelectSuggestionInReportingAddress = (suggestion) => {
    setReportingSuggestions([]);
    setShouldFetchSuggestions(false);
    setReportingInputValue(suggestion.description);
    console.log(
      "new location is",
      suggestion.geometry.location.lat,
      suggestion.geometry.location.lng
    );
    setMapReportingAddress({
      latitude: suggestion.geometry.location.lat,
      longitude: suggestion.geometry.location.lng,
      description: suggestion.description,
    });
  };

  const handleSelectSuggestionInDropAddress = (suggestion) => {
    setDropSuggestions([]);
    setShouldFetchSuggestions(false);
    setDropInputValue(suggestion.description);
    console.log(
      "new location is",
      suggestion.geometry.location.lat,
      suggestion.geometry.location.lng
    );
    setMapDropAddress({
      latitude: suggestion.geometry.location.lat,
      longitude: suggestion.geometry.location.lng,
      description: suggestion.description,
    });
  };

  const handleLabelSelect = (e) => {
    const selectedId = parseInt(e.target.value);
    if (!selectedLabelIds.includes(selectedId)) {
      setSelectedLabelIds([...selectedLabelIds, selectedId]);
    }
  };

  const handleBillingItemChange = (index, field, value) => {
    const updatedBillingItemPayload = [...billingItemPayload];
    updatedBillingItemPayload[index][field] = value;
    setBillingItemPayload(updatedBillingItemPayload);

    const updatedBillingItems = [...selectedBillingItems];
    updatedBillingItems[index][field] = value;
    setSelectedBillingItems(updatedBillingItems);
  };

  const removeBillingItem = (index) => {
    const updatedBillingItemPayload = [...billingItemPayload];
    updatedBillingItemPayload[index]["cost"] = 0;
    setBillingItemPayload(updatedBillingItemPayload);

    const updatedBillingItems = selectedBillingItems.filter(
      (_, i) => i !== index
    );
    setSelectedBillingItems(updatedBillingItems);
  };

  const addBillingItem = () => {
    setSelectedBillingItems([
      ...selectedBillingItems,
      { billingItemId: "", cost: "", imagePath: "", notes: "" },
    ]);
    setBillingItemPayload([
      ...billingItemPayload,
      { billingItemId: "", cost: "", imagePath: "", notes: "" },
    ]);
  };

  // Handle label removal
  const handleRemoveLabel = (id) => {
    setSelectedLabelIds(selectedLabelIds.filter((labelId) => labelId !== id));
  };

  useEffect(() => {
    const fetchCompanies = async () => {
      setLoadingCompanies(true);
      try {
        const params = new URLSearchParams({
          page_size: 1000,
          page: 1,
        });
        const response = await ApiManager.getAllCompanies(params);
        if (!response.ok) throw new Error("Network response was not ok");
        const json = await response.json();
        setCompanies(json || []);
      } catch (error) {
        console.error("Error fetching data:", error);
        setCompanies([]);
      } finally {
        setLoadingCompanies(false);
      }
    };
    const fetchDrivers = async () => {
      try {
        const params = new URLSearchParams({
          page_size: 1000,
          page: 1,
        });
        const response = await ApiManager.getAllDrivers(params);
        if (!response.ok) throw new Error("Network response was not ok");
        const json = await response.json();
        setDrivers(json || []);
      } catch (error) {
        console.error("Error fetching data:", error);
        setDrivers([]);
      }
    };
    const fetchCars = async () => {
      try {
        const params = new URLSearchParams({
          page_size: 1000,
          page: 1,
        });
        const response = await ApiManager.getAllCars(params);
        if (!response.ok) throw new Error("Network response was not ok");
        const json = await response.json();
        setCars(json || []);
      } catch (error) {
        console.error("Error fetching data:", error);
        setCars([]);
      }
    };
    const fetchCarTypes = async () => {
      setLoadingCarTypes(true);
      try {
        const params = new URLSearchParams({
          page_size: 1000,
          page: 1,
        });
        const response = await ApiManager.getCarType(params);
        if (!response.ok) throw new Error("Network response was not ok");
        const json = await response.json();
        setCarTypes(json || []);
      } catch (error) {
        console.error("Error fetching data:", error);
        setCarTypes([]);
      } finally {
        setLoadingCarTypes(false);
      }
    };

    const fetchTripTypes = async () => {
      setLoadingTripTypes(true);
      try {
        const params = new URLSearchParams({
          page_size: 1000,
          page: 1,
        });
        const response = await ApiManager.getAllTripTypes(params);
        if (!response.ok) throw new Error("Network response was not ok");
        const json = await response.json();
        setTripTypes(json || []);
      } catch (error) {
        console.error("Error fetching data:", error);
        setTripTypes([]);
      } finally {
        setLoadingTripTypes(false);
      }
    };

    const fetchLables = async () => {
      setLoadingLabels(true);
      try {
        const params = new URLSearchParams({
          page_size: 1000,
          page: 1,
        });
        const response = await ApiManager.getAllLabels(params);
        if (!response.ok) throw new Error("Network response was not ok");
        const json = await response.json();
        setLabels(json || []);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLabels([]);
      } finally {
        setLoadingLabels(false);
      }
    };
    const fetchBillingItems = async () => {
      try {
        const params = new URLSearchParams({
          page_size: 1000,
          page: 1,
        });
        const response = await ApiManager.getAllBillingItems(params);
        if (!response.ok) throw new Error("Network response was not ok");
        const json = await response.json();
        setBillingItems(json || []);
      } catch (error) {
        console.error("Error fetching data:", error);
        setBillingItems([]);
      }
    };
    const fetchCities = async () => {
      try {
        const params = new URLSearchParams({
          page_size: 1000,
          page: 1,
        });
        const response = await ApiManager.getAllCities(params);
        if (!response.ok) throw new Error("Network response was not ok");
        const json = await response.json();
        setCities(json || []);
      } catch (error) {
        console.error("Error fetching data:", error);
        setCities([]);
      }
    };

    const fetchGarages = async () => {
      try {
        const params = new URLSearchParams({
          page_size: 1000,
          page: 1,
        });
        const response = await ApiManager.getAllGarages(params);
        if (!response.ok) throw new Error("Network response was not ok");
        const json = await response.json();
        setGarageData(json || []);
      } catch (error) {
        console.error("Error fetching data:", error);
        setGarageData([]);
      }
    };
    fetchCities();
    fetchCompanies();
    if (
      tripInfo.driverTrip &&
      (tripInfo.tripStatus == "ALLOTTED" || tripInfo.tripStatus == "DISPATCHED")
    ) {
      fetchDrivers();
      fetchCars();
    }
    fetchCarTypes();
    fetchTripTypes();
    fetchLables();
    fetchBillingItems();
    fetchGarages();
  }, []);

  const addPassenger = () => {
    setPassengers([...passengers, { name: "", phone: "", email: "" }]);
  };

  const addAdditionalContact = () => {
    setAdditionalContacts([
      ...additionalContacts,
      { name: "", phone: "", email: "" },
    ]);
  };

  const removeAdditionalContact = (index) => {
    const updatedContacts = additionalContacts.filter((_, i) => i !== index);
    setAdditionalContacts(updatedContacts);
  };

  const handleAdditionalContactChange = (index, field, value) => {
    const updatedContacts = [...additionalContacts];
    updatedContacts[index][field] = value;
    setAdditionalContacts(updatedContacts);
  };

  const removePassenger = (index) => {
    const updatedPassengers = passengers.filter((_, i) => i !== index);
    setPassengers(updatedPassengers);
  };

  const handlePassengerChange = (index, field, value) => {
    const updatedPassengers = [...passengers];
    updatedPassengers[index][field] = value;
    setPassengers(updatedPassengers);
  };

  const handleGetPrice = async (event) => {
    setShowPrices(true);
    setLoadingPrice(true); // Start loading
    event.preventDefault(); // Prevent form submission reload

    const form = event.target.closest("form"); // This gets the closest form element
    if (!form) {
      console.error("Form not found");
      setLoadingPrice(false);
      return;
    }
    const formData = new FormData(form);

    try {
      const queryParams = new URLSearchParams({
        trip_type_id: parseInt(
          formData.get("tripType") ?? tripInfo?.tripType?.id
        ),
        car_type_id: parseInt(formData.get("carType") ?? tripInfo?.carType?.id),
        company_id: company,
        city: fromCity,
      });
      const response = await ApiManager.getCharges(queryParams);

      if (!response.ok) {
        throw new Error("Failed to fetch price");
      }
      const data = await response.json(); // Parse the JSON response
      setCharges(data);
      form.querySelector('[name="price"]').value =
        data?.rates?.base_rates || "";
      form.querySelector('[name="perExKmRate"]').value =
        data.rates?.extra_km_rates || "";
      form.querySelector('[name="perExTimeUnitRate"]').value =
        tripType && tripType.type === "day-km"
          ? data.rates?.extra_day_rates || ""
          : data.rates?.extra_hr_rates || "";
    } catch (err) {
      console.error("Error fetching price:", err);
      form.querySelector('[name="price"]').value = "";
      form.querySelector('[name="perExKmRate"]').value = "";
      form.querySelector('[name="perExTimeUnitRate"]').value = "";
    } finally {
      setLoadingPrice(false); // Stop loading
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const tripData = Object.fromEntries(formData.entries());

    const reportingAddress = mapViewToggles.reportingAddress
      ? tripData.reportingAddress
      : [
          manualReportingAddress.addressLine1,
          manualReportingAddress.addressLine2,
          manualReportingAddress.city,
          manualReportingAddress.state,
          manualReportingAddress.pincode,
        ]
          .filter((field) => field) // Remove empty fields
          .join(", "); // Join remaining fields with commas

    const dropAddress = mapViewToggles.dropAddress
      ? tripData.dropAddress
      : [
          manualDropAddress.addressLine1,
          manualDropAddress.addressLine2,
          manualDropAddress.city,
          manualDropAddress.state,
          manualDropAddress.pincode,
        ]
          .filter((field) => field) // Remove empty fields
          .join(", "); // Join remaining fields with commas

    // Format date and time to UNIX timestamp
    const scheduledStartTime =
      new Date(tripData.scheduledStartTime).getTime() / 1000;

    const formattedTripData = {
      tripId: tripInfo.tripId,
      companyId: parseInt(company), // Assuming it's an ID
      fromCity: fromCity,
      toCity: toCity,
      // shortReportingAddress: tripData.shortReportingAddress,
      carType: parseInt(tripData?.carType || tripInfo?.carType?.id), // Assuming it's an ID
      tripType: parseInt(tripData.tripType || tripInfo?.tripType?.id), // Assuming it's an ID
      garageId: parseInt(selectedGarage),
      scheduledStartTime: scheduledStartTime,
      scheduledEndTime: tripData.scheduledEndTime
        ? new Date(tripData.scheduledEndTime).getTime() / 1000
        : null,
      reportingTime: tripData.reportingTime
        ? new Date(tripData.reportingTime).getTime() / 1000
        : null,
      reportingAddress: reportingAddress,
      dropAddress: dropAddress,
      passengers: passengers.filter((p) => p.name || p.phone || p.email),
      contractAutoSwitchEnabled: contractAutoSwitchEnabled,
      ...((tripData.bookedByName ||
        tripData.bookedByPhone ||
        tripData.bookedByEmail) && {
        bookedBy: {
          name: tripData.bookedByName,
          phone: tripData.bookedByPhone,
          email: tripData.bookedByEmail,
        },
      }),
      driverTrip: {
        driverId: parseInt(tripData.driver),
        carId: parseInt(tripData.car),
        departTime: tripData.departTime
          ? new Date(tripData.departTime).getTime() / 1000
          : null,
        startTime: tripData.startTime
          ? new Date(tripData.startTime).getTime() / 1000
          : null,
        garageStartTime: tripData.garageStartTime
          ? new Date(tripData.garageStartTime).getTime() / 1000
          : null,
        endTime: tripData.endTime
          ? new Date(tripData.endTime).getTime() / 1000
          : null,
        garageEndTime: tripData.garageEndTime
          ? new Date(tripData.garageEndTime).getTime() / 1000
          : null,
        startKm: parseFloat(tripData.startKm),
        endKm: parseFloat(tripData.endKm),
        garageStartKm: parseFloat(tripData.garageStartKm),
        garageEndKm: parseFloat(tripData.garageEndKm),
        customerSignature: tripData.customerSignature || "",
        driverNotes: tripData.driverNotes || "",
      },
      // additionalContacts: additionalContacts.filter(c => c.name || c.phone || c.email), // Filter out empty contacts
      labels: selectedLabelIds,
      remarks: tripData.remarks || "",
      operatorNotes: tripData.operatorNotes || "",
      ...(((tripInfo.charges && Object.keys(tripInfo.charges).length > 0) ||
        showPrices) && {
        charges: {
          ...charges,
          rates: {
            ...charges.rates,
            base_rates: parseFloat(tripData.price) || 0,
            extra_km_rates: parseFloat(tripData.perExKmRate) || 0,
            ...(tripType?.type === "day-km" && {
              extra_day_rates: parseFloat(tripData.perExTimeUnitRate) || 0,
            }),
            ...(tripType?.type !== "day-km" && {
              extra_hr_rates: parseFloat(tripData.perExTimeUnitRate) || 0,
            }),
          },
        },
      }),
      reportingCoordinates: {
        latitude: mapReportingAddress.latitude,
        longitude: mapReportingAddress.longitude,
      },
      dropCoordinates: {
        latitude: mapDropAddress.latitude,
        longitude: mapDropAddress.longitude,
      },

      TripBillingItems: billingItemPayload
        .filter((item) => item.billingItemId) // Ensure billingItemId exists
        .map((item) => ({
          ...(item.id !== null && item.id !== undefined
            ? { id: Number(item.id) }
            : {}),
          billingItemId: Number(item.billingItemId),
          cost: parseFloat(item.cost),
          imagePath: item.imagePath || "",
          notes: item.notes || "",
        })),
      // operatorNotes: tripData.operatorNotes || "",
      // price: parseFloat(tripData.price) || 0,
      // perExKmRate: parseFloat(tripData.perExKmRate) || 0,
      // perExTimeUnitRate: parseFloat(tripData.perExTimeUnitRate) || 0,
    };

    // Object.keys(formattedTripData).forEach(
    //   (key) =>
    //     (formattedTripData[key] === null ||
    //       formattedTripData[key] === undefined ||
    //       (Array.isArray(formattedTripData[key]) &&
    //         formattedTripData[key].length === 0)) &&
    //     delete formattedTripData[key]
    // );

    console.log("Formatted Trip Data:", formattedTripData);
    try {
      console.log("Final JSON:", JSON.stringify(formattedTripData, null, 2));
      const response = await ApiManager.updateTrip(null, formattedTripData);
      if (response.ok) {
        // alert("Trip successfully created!");
        const data = await response.json(); // Parse the JSON response
        console.log("Fetched data:", data);
        console.log("trip Id:", data.trip.tripId);
        navigate(`/login/trips/booking-details/${data.trip.tripId}`, {
          state: {
            showToast: true,
            toastMessage: "Trip edited successfully!",
          },
        });
      } else {
        const errorData = await response.json();
        console.error("Error:", errorData);
        alert("Failed to create trip. Please try again.");
      }
    } catch (error) {
      console.error("Network Error:", error);

      if (error.response) {
        const errorText = await error.response.text(); // Log raw response
        console.error("Error Response:", errorText);
      }

      alert("Network error. Please check your connection.");
    }
    setEditTrip(false);
  };

  const showToast = (message) => {
    toast.success(message, {
      position: "top-center", //toast.POSITION.TOP_CENTER,
      autoClose: 3000, // 3 seconds
    });
  };

  return (
    <div className="addNewTrip">
      <div style={{ textAlign: "center" }}>
        <h3>Edit Trip</h3>
      </div>
      <form onSubmit={handleSubmit}>
        {tripInfo.driverTrip &&
          (tripInfo.tripStatus == "ALLOTTED" ||
            tripInfo.tripStatus == "DISPATCHED") && (
            <fieldset className="fieldset">
              <legend>Driver and Car Info</legend>
              <div className="row">
                <div className="formGroup">
                  <label>Driver *</label>
                  <select
                    name="driver"
                    required
                    className="input"
                    value={driverId}
                    onChange={(e) => setDriverId(e.target.value)}
                    disabled={tripInfo.tripStatus === "DISPATCHED"}
                  >
                    <option value="" disabled>
                      Select a driver
                    </option>
                    {(drivers || []).map((driver) => (
                      <option key={driver.id} value={driver.id}>
                        {driver.firstName} {driver.lastName}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="formGroup">
                  <label>Car *</label>
                  <select
                    name="car"
                    required
                    className="input"
                    value={carId}
                    onChange={(e) => setCarId(e.target.value)}
                    disabled={tripInfo.tripStatus == "DISPATCHED"}
                  >
                    <option value="" disabled>
                      Select a Car
                    </option>
                    {(cars || []).map((car) => (
                      <option key={car.id} value={car.id}>
                        {car.vehicleNo}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </fieldset>
          )}

        {tripInfo.tripStatus != "COMPLETED" && (
          <fieldset className="fieldset">
            <legend>Company Info</legend>
            <div className="formGroup">
              <label>Company *</label>
              <select
                name="company"
                required={tripInfo.tripStatus != "CREATED"}
                className="input"
                value={company}
                onChange={(e) => setCompany(e.target.value)}
              >
                <option value="" disabled>
                  Select a Company
                </option>
                {(companies || []).map((company) => (
                  <option key={company?.id} value={company?.id}>
                    {company?.name}
                  </option>
                ))}
              </select>
            </div>
          </fieldset>
        )}

        {tripInfo.tripStatus != "COMPLETED" && (
          <fieldset className="fieldset">
            <legend>Booked By</legend>
            <div className="row">
              <div className="formGroup">
                <label>Name</label>
                <input
                  type="text"
                  name="bookedByName"
                  className="input"
                  defaultValue={tripInfo?.bookedBy?.name}
                />
              </div>
              <div className="formGroup">
                <label>Phone Number</label>
                <input
                  type="tel"
                  name="bookedByPhone"
                  defaultValue={tripInfo?.bookedBy?.phone}
                  className="input"
                  pattern="[0-9]{10}" // For a 10-digit number
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    if (e.target.value.length > 10) {
                      e.target.value = e.target.value.slice(0, 10); // Limit to 10 digits
                    }
                  }}
                />
              </div>
              <div className="formGroup">
                <label>Email</label>
                <input
                  type="email"
                  name="bookedByEmail"
                  defaultValue={tripInfo?.bookedBy?.email}
                  className="input"
                />
              </div>
            </div>
          </fieldset>
        )}

        <fieldset className="fieldset">
          <legend>Passenger Details</legend>
          {(passengers || []).map((passenger, index) => (
            <div key={index} className="passengerRow">
              <div className="formGroup">
                <label>Passenger Name</label>
                <input
                  type="text"
                  value={passenger?.name}
                  onChange={(e) =>
                    handlePassengerChange(index, "name", e.target.value)
                  }
                  className="input"
                />
              </div>
              <div className="formGroup">
                <label>Passenger Phone Number</label>
                <input
                  type="tel"
                  value={passenger.phone}
                  onChange={(e) =>
                    handlePassengerChange(index, "phone", e.target.value)
                  }
                  className="input"
                />
              </div>
              <div className="formGroup">
                <label>Passenger Email</label>
                <input
                  type="email"
                  value={passenger.email}
                  onChange={(e) =>
                    handlePassengerChange(index, "email", e.target.value)
                  }
                  className="input"
                />
              </div>
              <button
                type="button"
                onClick={() => removePassenger(index)}
                className="removeButton"
              >
                X
              </button>
            </div>
          ))}

          <button
            type="button"
            onClick={addPassenger}
            className="addPassengerButton"
          >
            + Add Another Passenger
          </button>
        </fieldset>

        {tripInfo.tripStatus != "COMPLETED" && (
          <fieldset className="fieldset">
            <legend>Address Details</legend>
            <div className="row">
              <div className="formGroup">
                <label>From City *</label>
                <select
                  name="fromCity"
                  required={tripInfo.tripStatus != "CREATED"}
                  className="input"
                  value={fromCity}
                  onChange={(e) => setFromCity(e.target.value)}
                >
                  <option value="" disabled>
                    Select a city
                  </option>
                  {(cities || []).map((city, index) => (
                    <option key={index} value={city}>
                      {city}
                    </option>
                  ))}
                </select>
              </div>
              <div className="formGroup">
                <label>To City</label>
                <select
                  name="toCity"
                  required={tripInfo.tripStatus != "CREATED"}
                  className="input"
                  value={toCity}
                  onChange={(e) => setToCity(e.target.value)}
                >
                  <option value="" disabled>
                    Select a city
                  </option>
                  {cities.map((city, index) => (
                    <option key={index} value={city}>
                      {city}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="mapContainer">
              {/* Reporting Address Section */}
              <div className="mapSection">
                <div className="mapHeader">
                  <label>Reporting Address *</label>
                  <button
                    type="button"
                    className="manualEntryButton"
                    onClick={() => toggleView("reportingAddress")}
                  >
                    {mapViewToggles.reportingAddress
                      ? "Switch to Manual Entry"
                      : "Switch to Map Entry"}
                  </button>
                </div>
                {mapViewToggles.reportingAddress ? (
                  <div className="manualEntryForm">
                    <label>Enter Reporting Address *</label>
                    <div className="address-input-container">
                      <input
                        type="text"
                        name="reportingAddress"
                        className="input"
                        required={tripInfo.tripStatus != "CREATED"}
                        value={reportingInputValue}
                        onChange={handleReportingInputChange}
                        onFocus={() => setIsInputFocusedReporting(true)}
                        onBlur={() =>
                          setTimeout(
                            () => setIsInputFocusedReporting(false),
                            200
                          )
                        } // Delay to allow click on suggestion
                      />
                      {isLoading && (
                        <div className="loading-indicator">Loading...</div>
                      )}
                      {isInputFocusedReporting &&
                        reportingSuggestions.length > 0 && (
                          <ul className="suggestions-list">
                            {reportingSuggestions.map((suggestion, index) => (
                              <li
                                key={index}
                                className="suggestion-item"
                                onClick={() =>
                                  handleSelectSuggestionInReportingAddress(
                                    suggestion
                                  )
                                }
                              >
                                {suggestion.description}
                              </li>
                            ))}
                          </ul>
                        )}
                    </div>

                    <MapView
                      latitude={mapReportingAddress.latitude}
                      longitude={mapReportingAddress.longitude}
                      zoom={20}
                      height={300}
                    />
                  </div>
                ) : (
                  <div>
                    <ManualAddressForm
                      formData={manualReportingAddress}
                      onChange={handleManualReportingAddressChange}
                    >
                      {" "}
                    </ManualAddressForm>
                  </div>
                )}
              </div>

              {/* Drop Address Section */}
              <div className="mapSection">
                <div className="mapHeader">
                  <label>Drop Address *</label>
                  <button
                    type="button"
                    className="manualEntryButton"
                    onClick={() => toggleView("dropAddress")}
                  >
                    {mapViewToggles.dropAddress
                      ? "Switch to Manual Entry"
                      : "Switch to Map Entry"}
                  </button>
                </div>
                {mapViewToggles.dropAddress ? (
                  <div className="manualEntryForm">
                    <label>Enter Drop Address *</label>

                    <div className="address-input-container">
                      <input
                        type="text"
                        name="dropAddress"
                        placeholder="Enter Address"
                        className="input"
                        required={tripInfo.tripStatus != "CREATED"}
                        value={dropInputValue}
                        onChange={handleDropInputChange}
                        onFocus={() => setIsInputFocusedDrop(true)}
                        onBlur={() =>
                          setTimeout(() => setIsInputFocusedDrop(false), 200)
                        } // Delay to allow click on suggestion
                      />
                      {isLoading && (
                        <div className="loading-indicator">Loading...</div>
                      )}
                      {isInputFocusedDrop && dropSuggestions.length > 0 && (
                        <ul className="suggestions-list">
                          {dropSuggestions.map((suggestion, index) => (
                            <li
                              key={index}
                              className="suggestion-item"
                              onClick={() =>
                                handleSelectSuggestionInDropAddress(suggestion)
                              }
                            >
                              {suggestion.description}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>

                    <MapView
                      latitude={mapDropAddress.latitude}
                      longitude={mapDropAddress.longitude}
                      zoom={20}
                      height={300}
                    />
                  </div>
                ) : (
                  <div>
                    <ManualAddressForm
                      formData={manualDropAddress}
                      onChange={handleManualDropAddressChange}
                    >
                      {" "}
                    </ManualAddressForm>
                  </div>
                )}
              </div>
            </div>
          </fieldset>
        )}

        {tripInfo.tripStatus != "COMPLETED" && (
          <>
            <fieldset className="fieldset">
              <legend>Trip Details</legend>
              {/* First Row */}
              <div className="row">
                <div className="formGroup">
                  <label>Trip Type *</label>
                  <select
                    name="tripType"
                    required={tripInfo.tripStatus != "CREATED"}
                    className="input"
                    defaultValue={tripInfo?.tripType}
                    disabled={tripInfo?.tripType}
                    onChange={handleTripTypeChange}
                  >
                    <option value="" disabled>
                      Select a Trip Type
                    </option>
                    {(tripTypes || []).map((tripType) => (
                      <option key={tripType.id} value={tripType.id}>
                        {tripType.name}
                      </option>
                    ))}
                  </select>
                  {loadingTripTypes && <p>Loading Trip Types...</p>}
                </div>
                <div className="formGroup">
                  <label>Car Type *</label>
                  <select
                    name="carType"
                    required={tripInfo.tripStatus != "CREATED"}
                    className="input"
                    defaultValue={tripInfo?.carType}
                  >
                    <option value="" disabled>
                      Select a Car Type
                    </option>
                    {(carTypes || []).map((carType) => (
                      <option key={carType.id} value={carType.id}>
                        {carType.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="formGroup">
                  <label htmlFor="contractAutoSwitchEnabledToggle">Contract Auto Switch</label>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <label className="toggle-switch">
                      <input
                        id="contractAutoSwitchEnabledToggle"
                        type="checkbox"
                        checked={contractAutoSwitchEnabled}
                        onChange={() => setContractAutoSwitchEnabled((prev) => !prev)}
                      />
                      <span className="toggle-slider"></span>
                    </label>
                    <span>{contractAutoSwitchEnabled ? 'On' : 'Off'}</span>
                  </div>
                </div>
              </div>

              <div className="formGroup">
              <label>Garage </label>
              <select
                name="garage"
                className="input"
                value={selectedGarage}
                onChange={(e) => {setSelectedGarage(e.target.value)}}
              >
                <option value="" disabled>
                  Select Garage
                </option>
                {(garageData || []).map((garage) => (
                  <option key={garage.id} value={garage.id}>
                    {garage.address}
                  </option>
                ))}
              </select>
            </div>

              {/* Second Row */}
              <div className="row">
                <div className="formGroup">
                  <label>Scheduled Start Time *</label>
                  <input
                    type="datetime-local"
                    name="scheduledStartTime"
                    defaultValue={formatDateTime(
                      tripInfo?.scheduledStartTime,
                      "datetime-local"
                    )}
                    required={tripInfo.tripStatus != "CREATED"}
                    className="input"
                  />
                </div>
                <div className="formGroup">
                  <label>Scheduled End Time *</label>
                  <input
                    type="datetime-local"
                    name="scheduledEndTime"
                    required={tripInfo.tripStatus != "CREATED"}
                    className="input"
                    defaultValue={formatDateTime(
                      tripInfo?.scheduledEndTime,
                      "datetime-local"
                    )}
                  />
                </div>
                <div className="formGroup">
                  <label>Reporting Time *</label>
                  <input
                    type="datetime-local"
                    name="reportingTime"
                    defaultValue={formatDateTime(
                      tripInfo?.reportingTime,
                      "datetime-local"
                    )}
                    required={tripInfo.tripStatus != "CREATED"}
                    className="input"
                  />
                </div>
              </div>
            </fieldset>

            <fieldset className="fieldset">
              <legend>Charges</legend>

              <div className="row">
                {((tripInfo.charges &&
                  Object.keys(tripInfo.charges).length > 0) ||
                  showPrices) && (
                  <>
                    <div className="formGroup">
                      <label>Price*</label>
                      <input
                        type="text"
                        name="price"
                        defaultValue={tripInfo?.charges?.rates?.base_rates}
                        required={tripInfo.tripStatus != "CREATED"}
                        className="input"
                      />
                    </div>
                    <div className="formGroup">
                      <label>Per Extra KM rate*</label>
                      <input
                        type="text"
                        name="perExKmRate"
                        defaultValue={tripInfo?.charges?.rates?.extra_km_rates}
                        required={tripInfo.tripStatus != "CREATED"}
                        className="input"
                      />
                    </div>
                    <div className="formGroup">
                      <label>
                        {tripInfo?.tripType &&
                        tripInfo?.tripType?.type === "day-km"
                          ? "Per Extra Day rate *"
                          : "Per Extra Hr rate *"}
                      </label>
                      <input
                        type="text"
                        name="perExTimeUnitRate"
                        defaultValue={
                          tripInfo?.tripType?.type !== "day-km"
                            ? tripInfo?.charges?.rates?.extra_hr_rates
                            : tripInfo?.charges?.rates?.extra_day_rates
                        }
                        required={tripInfo.tripStatus != "CREATED"}
                        className="input"
                      />
                    </div>
                  </>
                )}
                <div className="formGroup getPriceButton">
                  {/* <button type="button" className="btn" onClick={getPrice}>Get Price</button> */}
                  <button
                    type="button"
                    onClick={handleGetPrice}
                    className="btn"
                    disabled={loadingPrice} // Disable button while loading
                  >
                    {loadingPrice ? "Fetching Price..." : "Get Price"}
                  </button>
                </div>
              </div>
            </fieldset>
          </>
        )}

        <fieldset className="fieldset">
          <legend>Billing Items</legend>
          {(selectedBillingItems || []).map((selectedBillingItem, index) => (
            <div key={index} className="passengerRow">
              <div className="formGroup">
                <label>Billing Item</label>
                <select
                  className="input"
                  value={selectedBillingItem.billingItemId}
                  onChange={(e) =>
                    handleBillingItemChange(
                      index,
                      "billingItemId",
                      e.target.value
                    )
                  }
                >
                  <option value="" disabled>
                    Select a billing Item
                  </option>
                  {billingItems.map((billingItem) => (
                    <option
                      key={billingItem.billingItemId}
                      value={billingItem.billingItemId}
                    >
                      {billingItem.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="formGroup">
                <label>Cost</label>
                <input
                  type="number"
                  value={selectedBillingItem.cost}
                  onChange={(e) =>
                    handleBillingItemChange(index, "cost", e.target.value)
                  }
                  className="input"
                />
              </div>


              <div className="formGroup">
                <div className="file-upload-section">
                  <div className="file-label-container">
                    <label>Receipt</label>
                    {selectedBillingItem.imagePath && (
                      <div className="file-preview">
                        <button
                          type="button"
                          className="view-receipt-btn"
                          onClick={() =>
                            fetchFile(selectedBillingItem.imagePath)
                          }
                        >
                          Receipt
                        </button>
                      </div>
                    )}
                  </div>
                  <input
                    type="file"
                    className="input"
                    onChange={(e) => handleFileUpload(e.target.files[0], index)}
                  />
                </div>
              </div>
              <div className="formGroup">
                <label>Notes</label>
                <input
                  type="textarea"
                  value={selectedBillingItem.notes}
                  onChange={(e) =>
                    handleBillingItemChange(index, "notes", e.target.value)
                  }
                  className="input"
                />
              </div>
              <button
                type="button"
                onClick={() => removeBillingItem(index)}
                className="removeButton"
              >
                X
              </button>
            </div>
          ))}

          <button
            type="button"
            onClick={addBillingItem}
            className="addPassengerButton"
          >
            + Add Billing Item
          </button>
        </fieldset>

        {(tripInfo.tripStatus == "COMPLETED" ||
          tripInfo.tripStatus == "ALLOTTED" ||
          tripInfo.tripStatus == "DISPATCHED") && (
          <fieldset className="fieldset">
            <legend>Driver Trip Details</legend>
            <div className="row">
              <div className="formGroup">
                <label>Depart Time </label>
                <input
                  type="datetime-local"
                  name="departTime"
                  defaultValue={formatDateTime(
                    tripInfo.driverTrip?.departTime,
                    "datetime-local"
                  )}
                  required={tripInfo.tripStatus != "DISPATCHED"}
                  className="input"
                />
              </div>
              <div className="formGroup">
                <label>Start Time </label>
                <input
                  type="datetime-local"
                  name="startTime"
                  defaultValue={formatDateTime(
                    tripInfo.driverTrip?.startTime,
                    "datetime-local"
                  )}
                  required={tripInfo.tripStatus != "CREATED"}
                  className="input"
                />
              </div>
              <div className="formGroup">
                <label>Garage Start Time </label>
                <input
                  type="datetime-local"
                  name="garageStartTime"
                  defaultValue={formatDateTime(
                    tripInfo.driverTrip?.garageStartTime,
                    "datetime-local"
                  )}
                  required={tripInfo.tripStatus != "CREATED"}
                  className="input"
                />
              </div>
            </div>

            {/* Third Row */}
            <div className="row">
              <div className="formGroup">
                <label>End Time </label>
                <input
                  type="datetime-local"
                  name="endTime"
                  defaultValue={formatDateTime(
                    tripInfo.driverTrip?.endTime,
                    "datetime-local"
                  )}
                  required={tripInfo.tripStatus != "CREATED"}
                  className="input"
                />
              </div>
              <div className="formGroup">
                <label>Garage End Time </label>
                <input
                  type="datetime-local"
                  name="garageEndTime"
                  defaultValue={formatDateTime(
                    tripInfo.driverTrip?.garageEndTime,
                    "datetime-local"
                  )}
                  required={tripInfo.tripStatus != "CREATED"}
                  className="input"
                />
              </div>
            </div>

            {/* Fourth Row */}
            <div className="row">
              <div className="formGroup">
                <label>Start KM </label>
                <input
                  type="text"
                  name="startKm"
                  defaultValue={tripInfo.driverTrip?.startKm}
                  required={tripInfo.tripStatus != "CREATED"}
                  className="input"
                />
              </div>
              <div className="formGroup">
                <label>End KM </label>
                <input
                  type="text"
                  name="endKm"
                  defaultValue={tripInfo.driverTrip?.endKm}
                  required={tripInfo.tripStatus != "CREATED"}
                  className="input"
                />
              </div>
              <div className="formGroup">
                <label>Garage Start KM </label>
                <input
                  type="text"
                  name="garageStartKm"
                  defaultValue={tripInfo.driverTrip?.garageStartKm}
                  required={tripInfo.tripStatus != "CREATED"}
                  className="input"
                />
              </div>
              <div className="formGroup">
                <label>Garage End KM </label>
                <input
                  type="text"
                  name="garageEndKm"
                  defaultValue={tripInfo.driverTrip?.garageEndKm}
                  required={tripInfo.tripStatus != "CREATED"}
                  className="input"
                />
              </div>
            </div>

            {/* Fifth Row */}
            <div className="row">
              <div className="formGroup">
                <label>Customer Signature</label>
                <textarea
                  name="customerSignature"
                  defaultValue={tripInfo.driverTrip?.customerSignature}
                  className="input"
                ></textarea>
              </div>
              <div className="formGroup">
                <label>Driver Notes</label>
                <textarea
                  name="driverNotes"
                  defaultValue={tripInfo.driverTrip?.driverNotes}
                  className="input"
                ></textarea>
              </div>
            </div>
          </fieldset>
        )}

        <div className="row">
          <div className="formGroup">
            <label>Remarks</label>
            <textarea
              name="remarks"
              defaultValue={tripInfo?.remarks}
              className="input remarks"
              rows="3"
            />
          </div>
          <div className="formGroup">
            <label>Operator Notes</label>
            <textarea
              name="operatorNotes"
              defaultValue={tripInfo?.operatorNotes}
              className="input operatorNotes"
              rows="3"
            />
          </div>
        </div>

        <fieldset className="fieldset">
          <legend>Labels</legend>
          <div className="formGroup">
            <label>Select Labels</label>
            <select
              className="input"
              defaultValue=""
              onChange={handleLabelSelect}
            >
              <option value="" disabled>
                Select a Label
              </option>
              {labels.map((label) => (
                <option key={label.id} value={label.id}>
                  {label.name}
                </option>
              ))}
            </select>

            {/* Display selected labels */}
            {selectedLabelIds.length > 0 && (
              <div className="selectedLabels">
                {selectedLabelIds.map((id) => {
                  const label = labels.find((label) => label.id === id);
                  if (!label) return null;

                  const backgroundColor = label.color;
                  const textColor = getContrastColor(backgroundColor);

                  return (
                    <div
                      key={id}
                      className="selectedLabel"
                      style={{ backgroundColor: label.color, color: textColor }}
                    >
                      {label.name}
                      <button
                        style={{ color: textColor }}
                        onClick={() => handleRemoveLabel(id)}
                      >
                        x
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </fieldset>

        {/* Submit Button */}
        <button type="submit" className="submitButton">
          Edit Trip
        </button>
      </form>
    </div>
  );
};

export default EditTrip;
